import general from './general'
import session from './session'
import users from './users'
import languages from './languages'
import configurations from './configurations'
import wialonUsers from './wialonUsers'
import units from './units'
import trailerProfileTemplates from './trailerProfileTemplates'
import vehicleTypes from './vehicleTypes'
import drivers from './drivers'
import mechanics from './mechanics'
import geofences from './geofences'
import groups from './groups'
import newReports from './newReports'
import notifications from './notifications'
import apiTokens from './apiTokens'
import unitDocuments from './unitDocuments'
import driverDocuments from './driverDocuments'
import accounts from './accounts'

export default {
  general,
  session,
  users,
  languages,
  configurations,
  wialonUsers,
  units,
  trailerProfileTemplates,
  vehicleTypes,
  drivers,
  geofences,
  groups,
  newReports,
  notifications,
  apiTokens,
  mechanics,
  unitDocuments,
  driverDocuments,
  accounts
}
